<template>
  <div id="popUp">
    <h5 style="padding: 50px">
      Song added to queue
    </h5>
  </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'

@Component
export default class AddedToQueuePopup extends Vue {
}
</script>

<style scoped lang="scss">
  #popUp {
    width: 200px;
    height: 200px;
    border-radius: 10px;
    position: absolute;
    top:0;
    bottom: 0;
    left: 0;
    right: 0;

    margin: auto;
    background-color: grey;
    opacity: 0.8;
  }
</style>
